import { SortOrder } from "element-ui/types/table";
import { PresetSortConditionItem, DocumentListSortItemKinds } from "./";

export class DocumentListPresetSortCondition {
  label: string;
  items: DocumentListPresetSortConditionItem[];
  isDefault: boolean;
  isCommon: boolean;
}

export class DocumentListPresetSortConditionItem implements PresetSortConditionItem {
  sortType?: DocumentListSortItemKinds;
  orderType: SortOrder;
}
